module.exports = __webpack_public_path__ + "img/public/SiteIcons/footerGlobalIocn.svg?79a9ddc3";